import { PageMenuItem } from '@components';
import { Container } from '@design-system';
import React from 'react';
import './MenuRichessesHumainesPage.scss';

import { AiFillIdcard } from 'react-icons/ai';
import { BsPersonFillExclamation } from 'react-icons/bs';
import { FaUmbrellaBeach } from 'react-icons/fa';
import { MdTimer } from 'react-icons/md';
import { RiStackFill } from 'react-icons/ri';
import { Outlet, useNavigate } from 'react-router-dom';

export const MenuRichessesHumainesPage: React.FC = () => {
    const navigate = useNavigate();

    return (
        <Container className="menu-richesses-humaines-page">
            <Container padding="none" row>
                <PageMenuItem title="Pointage" icon={<MdTimer />} onClick={() => navigate('/richesses-humaines/pointage')} color="yellow" />
                <PageMenuItem
                    title="Demandes d'absence"
                    icon={<FaUmbrellaBeach />}
                    onClick={() => navigate('/richesses-humaines/conges')}
                    color="yellow"
                />
                <PageMenuItem
                    title="Bibliothèque RH"
                    icon={<RiStackFill />}
                    onClick={() => navigate('/richesses-humaines/bibliotheque')}
                    color="yellow"
                />
                <PageMenuItem
                    title="Carte BTP"
                    icon={<AiFillIdcard />}
                    onClick={() => navigate('/richesses-humaines/carte-btp')}
                    color="yellow"
                />
                <PageMenuItem
                    title="Remontées RH"
                    icon={<BsPersonFillExclamation />}
                    onClick={() => navigate('/richesses-humaines/event-feedback')}
                    color="yellow"
                />
                {/* <PageMenuItem title="Demande de personnel" icon={<IoPersonAddSharp />} onClick={() => console.log('test')} color="yellow" />
                <PageMenuItem title="Demande de reconduction" icon={<FaRepeat />} onClick={() => console.log('test')} color="yellow" />
                <PageMenuItem title="Fin de mission" icon={<FaFlagCheckered />} onClick={() => console.log('test')} color="yellow" /> */}
            </Container>

            <Outlet />
        </Container>
    );
};
